import { FlexAnchorProps, HelpFlexAnchor } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { useHelpLink } from '../../../hooks/navigation'

export interface ContextualHelpLinkProps extends Omit<FlexAnchorProps, 'href'> {
  name?: string
}

export const ContextualHelpLink: FunctionComponent<ContextualHelpLinkProps> = ({
  name,
  ...props
}) => {
  const helpLink = useHelpLink(name)

  return (
    <HelpFlexAnchor
      fontFamily='body'
      fontWeight='normal'
      color='inherit'
      target='_blank'
      display='inline'
      href={helpLink ?? '#'}
      textDecoration='underline'
      {...props}
    />
  )
}
